const BASE_DELAY_MS = 1_000;
const MAX_DELAY_MS = 60_000;
const JITTER_MAX_MS = 1_000;

/**
 * Computes a reconnection delay using exponential backoff with jitter.
 * Matches the Go API client strategy in api/go/client/cache/cache.go.
 *
 * Keep in sync with frontend/vscode/desktop/src/environmentState.ts (reconnectDelay).
 *
 * @param attempt - zero-based retry count (0 = first retry)
 * @returns delay in milliseconds
 */
export function reconnectDelay(attempt: number): number {
    const exponential = Math.min(MAX_DELAY_MS, BASE_DELAY_MS * Math.pow(2, attempt));
    const jitter = Math.random() * JITTER_MAX_MS;
    return exponential + jitter;
}
